import values from '~/languages/en/main/values.js';
import hero from '~/languages/en/main/hero.js';
import how from '~/languages/en/main/how.js';
import why from '~/languages/en/main/why.js';
import touch from '~/languages/en/main/touch.js';
import start from '~/languages/en/main/start.js';
import media from '~/languages/en/main/media.js';
import journey from '~/languages/en/main/journey.js';

export default {
  values,
  hero,
  how,
  why,
  touch,
  start,
  media,
  journey,
};
